import { contactDetails } from "./_contact_details";
import { contactSummary } from "./_contact_summary";

export default {
  contactDetails,
  contactSummary
}
